import "./EmptyState.css"

export default function EmptyState(props) {
    const text = props.text
    return (
        <div className="h-100 w-full flex justify-center flex-col gap-6">
            <p className="font-bold text-lg">
                {text}
            </p>
        </div>
    )
}